export const ruTranslatedStrings = {
    "It will be active again shortly.":"Сервис скоро снова будет доступен.",
    "Thank you for your patience.":"Спасибо за ваше терпение.",
    "You don't have an account?":"У вас нет аккаунта?",
    "Register as a new user":"Зарегистрироваться как новый пользователь",
    "Register":"Регистрация",
    "University":"Университет",
    "Secondary school":"Средняя школа",
    "Primary school":"Начальная школа",
    "Private tutoring":"Частные уроки",
    "Online private tutoring":"Онлайн-репетиторство",
    "Language school":"Языковая школа",
    "I am not teaching yet":"Я пока / eщё не преподаю",
    "Face to Face":"Очное обучение",
    "Fully online":"Полностью онлайн",
    "Hybrid/Blended":"Гибридное / Смешанное обучение",
    "Task Based Language Teaching":"Обучение языку на основе коммуникативных заданий (TBLT)",
    "Content and Language Integrate Learning":"Предметно-языковое интегрированное обучение (CLIL)",
    "Project-based Learning":"Проектное обучение",
    "Traditional Teaching":"Традиционное обучение",
    "Language for Specific Purposes":"Язык для специальных целей",
    "Language for Academic Purposes":"Язык для академических целей",
    "English as a Medium of Instruction":"Английский как язык преподавания",
    "Afghanistan":"Афганистан",
    "Albania":"Албания",
    "Algeria":"Алжир",
    "American Samoa":"Американское Самоа",
    "Andorra":"Андорра",
    "Angola":"Ангола",
    "Anguilla":"Ангилья",
    "Antarctica":"Антарктида",
    "Antigua and Barbuda":"Антигуа и Барбуда",
    "Argentina":"Аргентина",
    "Armenia":"Армения",
    "Aruba":"Аруба",
    "Australia":"Австралия",
    "Austria":"Австрия",
    "Azerbaijan":"Азербайджан",
    "Bahamas (the)":"Багамские Острова",
    "Bahrain":"Бахрейн",
    "Bangladesh":"Бангладеш",
    "Barbados":"Барбадос",
    "Belarus":"Беларусь",
    "Belgium":"Бельгия",
    "Belize":"Белиз",
    "Benin":"Бенин",
    "Bermuda":"Бермудские острова",
    "Bhutan":"Бутан",
    "Bolivia (Plurinational State of)":"Боливия (Многонациональное Государство Боливия)",
    "Bonaire, Sint Eustatius and Saba":"Бонайре, Синт-Эстатиус и Саба",
    "Bosnia and Herzegovina":"Босния и Герцеговина",
    "Botswana":"Ботсвана",
    "Bouvet Island":"Остров Буве",
    "Brazil":"Бразилия",
    "British Indian Ocean Territory (the)":"Британская территория в Индийском океане",
    "Brunei Darussalam":"Бруней-Даруссалам",
    "Bulgaria":"Болгария",
    "Burkina Faso":"Буркина-Фасо",
    "Burundi":"Бурунди",
    "Cabo Verde":"Кабо-Верде",
    "Cambodia":"Камбоджа",
    "Cameroon":"Камерун",
    "Canada":"Канада",
    "Cayman Islands (the)":"Острова Кайман",
    "Central African Republic (the)":"Центральноафриканская Республика",
    "Chad":"Чад",
    "Chile":"Чили",
    "China":"Китай",
    "Christmas Island":"Остров Рождества",
    "Cocos (Keeling) Islands (the)":"Кокосовые (Килинг) острова",
    "Colombia":"Колумбия",
    "Comoros (the)":"Коморы",
    "Congo (the Democratic Republic of the)":"Демократическая Республика Конго",
    "Congo (the)":"Республика Конго",
    "Cook Islands (the)":"Острова Кука",
    "Costa Rica":"Коста-Рика",
    "Croatia":"Хорватия",
    "Cuba":"Куба",
    "Curaçao":"Кюрасао",
    "Cyprus":"Кипр",
    "Czechia":"Чехия",
    "Côte d'Ivoire":"Кот-д'Ивуар",
    "Denmark":"Дания",
    "Djibouti":"Джибути",
    "Dominica":"Доминика",
    "Dominican Republic (the)":"Доминиканская Республика",
    "Ecuador":"Эквадор",
    "Egypt":"Египет",
    "El Salvador":"Сальвадор (Республика Эль-Сальвадор)",
    "Equatorial Guinea":"Экваториальная Гвинея",
    "Eritrea":"Эритрея",
    "Estonia":"Эстония",
    "Eswatini":"Эсватини",
    "Ethiopia":"Эфиопия",
    "Falkland Islands (the) [Malvinas]":"Фолклендские острова (Мальвинские)",
    "Faroe Islands (the)":"Фарерские острова",
    "Fiji":"Фиджи",
    "Finland":"Финляндия",
    "France":"Франция",
    "French Guiana":"Французская Гвиана",
    "French Polynesia":"Французская Полинезия",
    "French Southern Territories (the)":"Французские Южные и Антарктические территории",
    "Gabon":"Габон",
    "Gambia (the)":"Гамбия",
    "Georgia":"Грузия",
    "Germany":"Германия",
    "Ghana":"Гана",
    "Gibraltar":"Гибралтар",
    "Greece":"Греция",
    "Greenland":"Гренландия",
    "Grenada":"Гренада",
    "Guadeloupe":"Гваделупа",
    "Guam":"Гуам",
    "Guatemala":"Гватемала",
    "Guernsey":"Гернси",
    "Guinea":"Гвинея",
    "Guinea-Bissau":"Гвинея-Бисау",
    "Guyana":"Гайана",
    "Haiti":"Гаити",
    "Heard Island and McDonald Islands":"Остров Херд и острова Макдональд",
    "Holy See (the)":"Святой Престол",
    "Honduras":"Гондурас",
    "Hong Kong":"Гонконг",
    "Hungary":"Венгрия",
    "Iceland":"Исландия",
    "India":"Индия",
    "Indonesia":"Индонезия",
    "Iran (Islamic Republic of)":"Иран (Исламская Республика)",
    "Iraq":"Ирак",
    "Ireland":"Ирландия",
    "Isle of Man":"Остров Мэн",
    "Israel":"Израиль",
    "Italy":"Италия",
    "Jamaica":"Ямайка",
    "Japan":"Япония",
    "Jersey":"Джерси",
    "Jordan":"Иордания",
    "Kazakhstan":"Казахстан",
    "Kenya":"Кения",
    "Kiribati":"Кирибати",
    "Korea (the Democratic People's Republic of)":"Корейская Народно-Демократическая Республика",
    "Korea (the Republic of)":"Республика Корея",
    "Kuwait":"Кувейт",
    "Kyrgyzstan":"Киргизия",
    "Lao People's Democratic Republic (the)":"Лаос (Лаосская Народно-Демократическая Республика)",
    "Latvia":"Латвия",
    "Lebanon":"Ливан",
    "Lesotho":"Лесото",
    "Liberia":"Либерия",
    "Libya":"Ливия",
    "Liechtenstein":"Лихтенштейн",
    "Lithuania":"Литва",
    "Luxembourg":"Люксембург",
    "Macao":"Макао",
    "Madagascar":"Мадагаскар",
    "Malawi":"Малави",
    "Malaysia":"Малайзия",
    "Maldives":"Мальдивы",
    "Mali":"Мали",
    "Malta":"Мальта",
    "Marshall Islands (the)":"Маршалловы Острова",
    "Martinique":"Мартиника",
    "Mauritania":"Мавритания",
    "Mauritius":"Маврикий",
    "Mayotte":"Майотта",
    "Mexico":"Мексика",
    "Micronesia (Federated States of)":"Микронезия (Федеративные Штаты)",
    "Moldova (the Republic of)":"Молдова (Республика)",
    "Monaco":"Монако",
    "Mongolia":"Монголия",
    "Montenegro":"Черногория",
    "Montserrat":"Монтсеррат",
    "Morocco":"Марокко",
    "Mozambique":"Мозамбик",
    "Myanmar":"Мьянма",
    "Namibia":"Намибия",
    "Nauru":"Науру",
    "Nepal":"Непал",
    "Netherlands (the)":"Нидерланды",
    "New Caledonia":"Новое Каледония",
    "New Zealand":"Новое Зеландия",
    "Nicaragua":"Никарагуа",
    "Niger (the)":"Нигер",
    "Nigeria":"Нигерия",
    "Niue ":"Ниуэ",
    "Norfolk Island":"Остров Норфолк",
    "Northern Mariana Islands (the)":"Северные Марианские Острова",
    "Norway":"Норвегия",
    "Oman":"Оман",
    "Pakistan":"Пакистан",
    "Palau":"Палау",
    "Palestine, State of":"Государство Палестина",
    "Panama":"Панама",
    "Papua New Guinea":"Папуа — Новое Гвинея",
    "Paraguay":"Парагвай",
    "Peru":"Перу",
    "Philippines (the)":"Филиппины",
    "Pitcairn":"Острова Питкэрн",
    "Poland":"Польша",
    "Portugal":"Португалия",
    "Puerto Rico":"Пуэрто-Рико",
    "Qatar":"Катар",
    "Republic of North Macedonia":"Республика Северная Македония",
    "Romania":"Румыния",
    "Russian Federation (the)":"Российская Федерация",
    "Rwanda":"Руанда",
    "Réunion":"Реюньон",
    "Saint Barthélemy":"Сен-Бартелеми",
    "Saint Helena, Ascension and Tristan da Cunha":"Острова Святой Елены, Вознесения и Тристан-да-Кунья",
    "Saint Kitts and Nevis":"Сент-Китс и Невис",
    "Saint Lucia":"Сент-Люсия",
    "Saint Martin (French part)":"Сен-Мартен (французская часть)",
    "Saint Pierre and Miquelon":"Сен-Пьер и Микелон",
    "Saint Vincent and the Grenadines":"Сент-Винсент и Гренадины",
    "Samoa":"Самоа",
    "San Marino":"Сан-Марино",
    "Sao Tome and Principe":"Сан-Томе и Принсипи",
    "Saudi Arabia":"Саудовская Аравия",
    "Senegal":"Сенегал",
    "Serbia":"Сербия",
    "Seychelles":"Сейшельские Острова",
    "Sierra Leone":"Сьерра-Леоне",
    "Singapore":"Сингапур",
    "Sint Maarten (Dutch part)":"Синт-Мартен (нидерландская часть)",
    "Slovakia":"Словакия",
    "Slovenia":"Словения",
    "Solomon Islands":"Соломоновы Острова",
    "Somalia":"Сомали",
    "South Africa":"Южно-Африканская Республика",
    "South Georgia and the South Sandwich Islands":"Южная Георгия и Южные Сандвичевы Острова",
    "South Sudan":"Южный Судан",
    "Spain":"Испания",
    "Sri Lanka":"Шри-Ланка",
    "Sudan (the)":"Судан",
    "Suriname":"Суринам",
    "Svalbard and Jan Mayen":"Шпицберген и Ян-Майен",
    "Sweden":"Швеция",
    "Switzerland":"Швейцария",
    "Syrian Arab Republic":"Сирийская Арабская Республика",
    "Taiwan":"Тайвань",
    "Tajikistan":"Таджикистан",
    "Tanzania, United Republic of":"Танзания, Объединенная Республика Танзания",
    "Thailand":"Таиланд",
    "Timor-Leste":"Восточный Тимор",
    "Togo":"Того",
    "Tokelau":"Токелау",
    "Tonga":"Тонга",
    "Trinidad and Tobago":"Тринидад и Тобаго",
    "Tunisia":"Тунис",
    "Turkey":"Турция",
    "Turkmenistan":"Туркменистан",
    "Turks and Caicos Islands (the)":"Острова Теркс и Кайкос",
    "Tuvalu":"Тувалу",
    "Uganda":"Уганда",
    "Ukraine":"Украина",
    "United Arab Emirates (the)":"Объединённые Арабские Эмираты",
    "United Kingdom of Great Britain and Northern Ireland (the)":"Соединённое Королевство Великобритании и Северной Ирландии",
    "United States Minor Outlying Islands (the)":"Внешние малые острова США",
    "United States of America (the)":"Соединённые Штаты Америки",
    "Uruguay":"Уругвай",
    "Uzbekistan":"Узбекистан",
    "Vanuatu":"Вануату",
    "Venezuela (Bolivarian Republic of)":"Венесуэла (Боливарианская Республика)",
    "Viet Nam":"Вьетнам",
    "Virgin Islands (British)":"Виргинские острова (Великобритания)",
    "Virgin Islands (U.S.)":"Виргинские острова (США)",
    "Wallis and Futuna":"Уоллис и Футуна",
    "Western Sahara":"Западная Сахара",
    "Yemen":"Йемен",
    "Zambia":"Замбия",
    "Zimbabwe":"Зимбабве",
    "Åland Islands":"Аландские острова",
    "No organization selected.":"Организация не выбрана.",
    "Users groups":"Группы пользователей",
    "New group":"Новое группа",
    "Id":"Идентификатор",
    "Name":"Имя",
    "Users":"Пользователи",
    "Actions":"Действия",
    "1 user":"1 пользователь",
    "users":"пользователи",
    "No users assigned":"Нет назначенных пользователей",
    "Edit group":"Редактировать группу",
    "Delete group":"Удалить группу",
    "Enter a name":"Введите имя",
    "Description":"Описание",
    "Save":"Сохранить",
    "You are about to delete organization content {{name}}. 'This action cannot be undone. Are you sure you want to proceed?":"Вы собираетесь удалить название организации {{name}}. Это действие нельзя отменить. Вы уверены, что хотите продолжить?",
    "Yes":"Да",
    "No":"Нет",
    "Add new group":"Добавить новую группу",
    "Conditions of Use":"Условия использования",
    "Introduction":"Введение",
    "The taskGen Project is a three-year research initiative supported by grant PID2020-119009RB-I00 from the Spanish Ministry of Science and Innovation (MCIN) and the National Research Agency (AEI) [Reference: 10.13039/501100011033]. At the University of Barcelona, we have developed the taskGen web-based tool for the automated design of second/foreign language communicative tasks. Participants engaging in the pilot evaluation through the taskGen platform are required to read and agree to the terms outlined below.":"Проект taskGen — это трёхлетняя исследовательская инициатива, поддержанная грантом PID2020-119009RB-I00 от Министерства науки и инноваций Испании (MCIN) и Национального агентства исследований (AEI) [Ссылка: 10.13039/501100011033]. В Барселонском университете мы разработали веб-приложение taskGen для автоматического проектирования коммуникативных заданий по изучению второго/иностранного языка. Участники, принимающие участие в пилотной оценке через платформу taskGen, обязаны прочитать и согласиться с условиями, изложенными ниже.",
    "Consent":"Согласие",
    "Participants engaging in this pilot evaluation of the taskGen tool implicitly agree to these terms upon logging into the platform.":"Участники, участвующие в этой пилотной оценке приложения taskGen, автоматически соглашаются с этими условиями при входе на платформу.",
    "Aim of this research project":"Цель исследовательского проекта",
    "The aim is to develop a web-based tool that will assist teachers in the design of second and foreign language tasks. The goal is for the tool to help teacher create, clone, share, download/upload onto teaching platforms, and to analyze texts for the automatic detection of linguistic features. Additionally, the tool can be used for training as it contains aids with information about task design.":"Цель состоит в разработке веб-приложения, который поможет преподавателям создавать задания по изучению второго или иностранного языка. Цель приложения — помочь преподавателям создавать, дублировать, делиться, загружать задания на обучающие платформы и анализировать тексты для автоматического выявления лингвистических особенностей. Кроме того, приложение можно использовать для обучения учителей/разработчиков заданий, так как он содержит справочные материалы по проектированию заданий.",
    "Kind participation":"Добровольное участие",
    "taskGen users can design, organize, store, and share tasks with other users within the taskGen system. Participation may be stopped at any point. Participants can delete their accounts and leave the system.":"Пользователи приложения taskGen могут создавать, организовывать, сохранять и делиться заданиями с другими пользователями внутри системы taskGen. Участники могут в любой момент удалить свои аккаунты и покинуть систему.",
    "Types of data to be processed":"Типы обрабатываемых данных",
    "During the implementation of the pilot, the tool will process (retrieve, store, produce, relate, analyze and use automatically):":"Во время реализации пилотного проекта приложение будет обрабатывать (извлекать, хранить, производить, связывать, анализировать и использовать автоматически):",
    "From your profile data: educational context, teaching modality, teaching approach, country, years of experience. No information related to your identity will be processed, analysed or shared.":"Из данных вашего профиля: образовательный контекст, форма преподавания, подход к преподаванию, страна, опыт работы. Не будет обрабатываться, анализироваться или передаваться никакая информация, связанная с вашей личностью.",
    "System use data: timestamps of platform interaction, mouse-click tracking, text length, choice of pre-task and post-task types, choice of text editing and analysis tools, design options, and use of aids.":"Данные использования системы: временные метки взаимодействия с платформой, отслеживание кликов мыши, длина текста, выбор типов пре-задания и пост-задания, выбор инструментов редактирования и анализа текста, параметры дизайна и использование справочных материалов.",
    "Database Security":"Безопасность базы данных",
    "Collected data will be securely stored, with access limited to authorized personnel only. Stringent security measures will be employed to protect confidentiality.":"Собранные данные будут храниться безопасно, доступ к ним ограничен только авторизованным персоналом. Будут применяться строгие меры безопасности для защиты конфиденциальности.",
    "Data retrieval and treatment":"Извлечение и обработка данных",
    "Standard and secure data analytics tools will be used to retrieve and analyze the collected data exclusively for research purposes.":"Для извлечения и анализа собранных данных будут использоваться стандартные и безопасные инструменты анализа данных, предназначенные исключительно для исследовательских целей.",
    "Objectives and legal basis for the processing and treatment of data":"Цели и правовая основа обработки данных",
    "The processing and treatment of the data follows the principles of the data protection law (GDPR) 2016-679 of the European Union as well as the Catalan Agency of Data Protection.":"Обработка и использование данных соответствует принципам законодательства о защите данных (GDPR) 2016-679 Европейского Союза, а также Каталонского агентства защиты данных.",
    "Data will be stored until four years after the end of the project. The treatment of personal data is carried out at/by the General Secretary of Universitat de Barcelona, Gran Via de les Corts Catalanes, 585, 08007 Barcelona. The email address is secretaria.general@ub.edu. You can revoke your consent at any point by contacting the email address above.":"Данные будут храниться в течение четырёх лет после завершения проекта. Обработка персональных данных осуществляется Генеральным секретарём Барселонского университета, Gran Via de les Corts Catalanes, 585, 08007, Барселона. Email: secretaria.general@ub.edu . Вы можете отозвать своё согласие в любой момент, связавшись по указанному адресу электронной почты.",
    "Research Purposes and confidentiality":"Научные цели и конфиденциальность",
    "The collected data will be used solely for research purposes, enhancing understanding, improving user experience, and informing project development. The results of the project will appear in academic publications and organizations (e.g. Ministry of Education, statistical services, etc.) or in the media with no reference to any data related to participants’ personal information, hence ensuring security, privacy and anonymity. No commercial utilization or third-party sharing will occur.":"Собранные данные будут использоваться исключительно в научных целях, направленных на углубление понимания, улучшение опыта пользователей и развитие проекта. Результаты проекта будут опубликованы в академических изданиях и организациях (например, Министерстве образования, статистических службах и т. д.) или в средствах массовой информации без ссылок на персональные данные участников, обеспечивая безопасность, конфиденциальность и анонимность. Коммерческое использование или передача третьим лицам исключены.",
    "Ethical Compliance":"Соблюдение этических норм",
    "The data collection process strictly adheres to ethical standards as set by the University of Barcelona, ensuring responsible handling of information throughout collection, storage, and analysis.":"Процесс сбора данных строго соответствует этическим стандартам, установленным Барселонским университетом, обеспечивая ответственное обращение с информацией на всех этапах: сбора, хранения и анализа.",
    "Modification of Terms":"Изменение условий",
    "Terms may be modified during the project, and participants will be notified of any changes.":"Условия могут изменяться в ходе проекта, участники будут уведомлены обо всех изменениях.",
    "By utilizing the platform, participants acknowledge their understanding and agreement with these terms. Failure to comply may result in access termination.":"Используя платформу, участники подтверждают своё понимание и согласие с данными условиями. Несоблюдение условий может привести к прекращению доступа.",
    "If you consider that your rights have not been adequately addressed, you can notify the UB Data Protection Delegate: protecciodedades@ub.edu or Travessera de les Corts, 131-159, Pabellón Rosa, 08028 Barcelona.":"Если вы считаете, что ваши права не были должным образом учтены, вы можете сообщить представителю по защите данных Барселонского университета: protecciodedades@ub.edu или Travessera de les Corts, 131-159, Pabellón Rosa, 08028 Barcelona.",
    "Likewise, you have the right to file a claim with the Catalan Data Protection Authority.":"Вы также имеете право подать жалобу в Каталонское агентство защиты данных.",
    "If you have any questions, you can contact the taskGen team at taskgenproject@gmail.com":"Если у вас есть вопросы, вы можете связаться с командой taskGen по адресу taskgenproject@gmail.com",
    "By accepting these terms and conditions, I hereby certify that I have permission to use and release the materials included in my task designs. I am responsible for the materials that I will be sharing with other users within taskGen.":"Принимая эти условия, я подтверждаю, что у меня есть разрешение на использование и распространение материалов, включённых в мои задания. Я несу ответственность за материалы, которые буду делиться с другими пользователями внутри taskGen.",
    "Data treatment":"Обработка данных",
    "Update profile":"Обновить профиль",
    "Profile":"Профиль",
    "Logout your taskGen session":"Выйти из сеанса taskGen",
    "Logout":"Выход",
    "Check your inbox and follow the instructions to finish your registration.":"Проверьте свой почтовый ящик и следуйте инструкциям, чтобы завершить регистрацию.",
    "There was a problem with the registration. It is possible that a user with the same Email is already registered. Please try again later or write to us at info@taskgen.eu.":"Возникла проблема с регистрацией. Возможно, пользователь с таким же адресом электронной почты уже зарегистрирован. Пожалуйста, попробуйте позже или напишите нам по адресу : info@taskgen.eu .",
    "Email Address":"Адрес электронной почты",
    "By clicking this box, I state that I have read and understood the ":"Отмечая этот пункт, я подтверждаю, что ознакомился(лась) и согласен(на) с ",
    "terms and conditions":"условия использования",
    "Loading...":"Загрузка...",
    "A new password has been sent to your inbox. You can change your password in your profile once you log in.":"Новый пароль отправлен в ваш почтовый ящик. Вы можете изменить пароль в своем профиле после входа в систему.",
    "There was a problem resetting your password. Please try again later or write to us at info@taskgen.eu.":"Возникла проблема с восстановлением пароля. Пожалуйста, попробуйте позже или напишите нам по адресу: info@taskgen.eu .",
    "User or password are not valid":"Имя пользователя или пароль неверны",
    "Reset your password":"Восстановить пароль",
    "You don't remember your password?":"Вы не помните свой пароль?",
    "Reset it":"Восстановить",
    "Login":"Войти",
    "We would like to kindly ask you complete you user profile. You will do this only once and you can modify your profile at any point.":"Мы просим вас заполнить свой профиль. Это нужно сделать один раз, но вы сможете изменить его в любой момент.",
    "Please, tell us where do you usually teach.":"Пожалуйста, укажите, где вы обычно преподаёте.",
    "Please, tell us how do you typically teach.":"Пожалуйста, расскажите, как вы обычно преподаёте.",
    "Please, tell us your general teaching framework.":"Пожалуйста, опишите вашу общую методику преподавания.",
    "First name(s)":"Имя (имена)",
    "Family name(s)":"Фамилия(и)",
    "Other...":"Другое...",
    "Special Needs":"Особые потребности",
    "Have you ever trained using TBLT?":"Проходили ли вы обучение по методике TBLT? / Проходили ли вы обучение с использованием TBLT?",
    "Region or State":"Регион или штат",
    "How many years of teaching experience do you have?":"Сколько лет у вас преподавательского стажа?",
    "Tell us for how long you have been teaching in TLBT":"Укажите, как долго вы преподаёте по методике TLBT",
    "Edit profile":"Редактировать профиль",
    "Close window/tab":"Закрыть окно/вкладку",
    "Shared with students":"Вариант для студентов",
    "Shared with teachers":"Вариант для преподавателей",
    "Title":"Название",
    "Authorship":"Авторство",
    "Student's proficiency level":"Уровень владения языком у студентов",
    "Aims":"Цели",
    "Pre-Task":"Пре-задание",
    "There are no pre-tasks defined":"Нет определённых пре-заданий",
    "Main Tasks":"Основные задания",
    "There are no tasks":"Нет заданий",
    "Post-Task":"Пост-задание",
    "There are no post-tasks":"Нет пост-заданий",
    "Close":"Закрыть",
    "Aim and instructions":"Цель и инструкции",
    "Last updated":"Последнее обновление",
    "Shared by user":"Задание предоставленный пользователем",
    "Shared by group":"Задание предоставленный группой",
    "Duplicate":"Дублировать",
    "Sharing link copied to your clipboard.":"Ссылка для доступа скопирована в буфер обмена",
    "Edit":"Редактировать",
    "Share":"Поделиться",
    "Share link":"Поделиться ссылкой",
    "Move Up":"Переместить вверх",
    "Move Down":"Переместить вниз",
    "Delete":"Удалить",
    "Share task":"Поделиться заданием",
    "Share with users":"Поделиться с пользователями",
    "Shared with someone at":"Доступ предоставлен пользователю из заведения",
    "Search users...":"Поиск пользователей...",
    "Select the users with whom you want to share the task:":"Выберите пользователей, с которыми хотите поделиться заданием:",
    "Task is shared with the following users:":"Задание передано следующим пользователям:",
    "Share with groups":"Поделиться с группами",
    "Select the groups you want to share the task:":"Выберите группы, с которыми хотите поделиться заданием:",
    "Task is shared with the following groups:":"Задание передано следующим группам:",
    "Cancel":"Отменить",
    "My design":"Мой дизайн",
    "Teacher version":"Версия преподавателя",
    "Preview":"Предпросмотр",
    "Download SCORM":"Скачать SCORM",
    "Download HTML":"Скачать HTML",
    "Student version":"Версия студента",
    "Sessions":"Занятия",
    "Session name":"Название занятия",
    "Update":"Обновить",
    "Add session":"Добавить занятие",
    "Type":"Тип",
    "Clone pre-task":"Дублировать пре-задание",
    "Edit pre-task":"Редактировать пре-задание",
    "Delete pre-task":"Удалить пре-задание",
    "Are you sure you want to delete the pre-task ":"Вы уверены, что хотите удалить пре-задание",
    "This action cannot be undone.":"Это действие нельзя отменить.",
    "Are you sure you want to delete the post-task?":"Вы уверены, что хотите удалить пост-задание",
    "Pos-Task has been clonned as a Pre-Task.":"Пост-задание было дублировано как пре-задание.",
    "Write the name of the task":"Введите название задания",
    "Task metadata":"Метаданные задания",
    "Author(s)":"Автор(ы)",
    "Task language":"Язык задания",
    "Catalan":"Каталанский",
    "English":"Английский",
    "Spanish":"Испанский",
    "Russian":"Русский",
    "Language in which the task is designed":"Язык, на котором создано задание",
    "General aim of the task":"Основная цель задания",
    "Specific aim of the task":"Конкретная цель задания",
    "Other (please specify)":"Другое (укажите)",
    "This information will be especially useful if you intend to share the task.":"Эта информация будет особенно полезна, если вы планируете делиться заданием.",
    "New Pre-Task":"Новое пре-задание",
    "Use a text for reading comprehension and to highlight language input":"Использовать текст для развития навыков чтения и демонстрации языкового материала",
    "Text":"Текст",
    "Audios are great sources of input.":"Аудиозаписи — отличный источник языкового материала.",
    "Audio":"Аудио",
    "Videos are excellent sources of ‘multimodal’ input. They present together images, text, and audio in meaningful ways that facilitate second language learning.":"Видео — отличный источник «мульти-модального» языкового материала. Они объединяют изображения, текст и звук, способствуя эффективному изучению второго/иностранного языка.",
    "Video":"Видео",
    "Reading comprehension dialogues provide an opportunity for both reading and speaking practice.":"Диалоги для понимания текста дают возможность практиковать как чтение, так и говорение.",
    "Written dialogue":"Письменный диалог",
    "Photos provide excellent opportunities to generate communication and interaction.":"Фотографии предоставляют отличную возможность для развития коммуникации и взаимодействия.",
    "Photo":"Фото",
    "Video and audio transcripts provide exposure to rich and meaningful input that can be used in several ways.":"Транскрипты видео и аудио предоставляют богатый и значимый материал, который можно использовать различными способами.",
    "Speech transcript":"Транскрипт речи",
    "Interaction activities can be used in preparation for the main task.":"Интерактивные упражнения можно использовать в качестве подготовки к основному заданию.",
    "Interaction activity":"Интерактивное упражнение",
    "Game":"Игра",
    "Warm-ups at the beginning of a lesson may serve as a smooth introduction to the topic/content of the lesson, as an opportunity for learners to progressively switch to the second or foreign language, and as a way to get into the language lesson mood.":"Разминка в начале урока может служить плавным введением в тему/содержание урока, возможностью для учащихся постепенно переключиться на второй или иностранный язык, а также способом настроиться на занятие.",
    "Warm-up":"Разминка",
    "Main Task":"Основное задание",
    "New Main Task":"Новое основное задание",
    "New Post-Task":"Новое пост-задание",
    "Task repetition is known to have a positive impact on all aspects of production and learning.":"Повторение задания положительно влияет на все аспекты речевой деятельности и обучения.",
    "Task repetition":"Повторение задания",
    "Explicit explanations can help solve or consolidate language issues that came up during task performance.":"Эксплициные объяснения помогают решить или закрепить языковые проблемы, возникшие во время выполнения задания.",
    "Explicit explanation":"Ясное объяснение",
    "Written to Oral / Oral to Written":"Письменное в устное / устное в письменное",
    "Task model and exercises":"Модель задания и упражнения",
    "Exercises":"Упражнения",
    "Shared task":"Задание с совместным доступом",
    "The task":"Задание",
    "is already shared with you.":"доступ к заданию уже предоставлен",
    "Do you want to add the task ":"Вы хотите добавить задание ",
    "to the collection of tasks shared with you?":"в коллекцию заданий, которыми с вами поделились?",
    "If you accept this shared task, you will be allowed to clone it to create your own version of the task.":"Получив доступ к заданию, вы сможете дублировать его и создать собственную копию.",
    "Accept":"Принять",
    "Reject":"Отклонить",
    "Delete task":"Удалить задание",
    "You are about to delete the task":"Вы собираетесь удалить задание",
    "Add new Task Example":"Добавить новый пример задания",
    "Select the tasks you want to add as examples:":"Выберите задания, которые вы хотите добавить в качестве примеров:",
    "Add selected tasks":"Добавить выбранные задания",
    "Delete Task Example":"Удалить пример задания",
    "You are about to delete the task example":"Вы собираетесь удалить пример задания",
    "Are you sure you want to proceed?":"Вы уверены, что хотите продолжить?",
    "No task example selected.":"Не выбрано примера задания.",
    "New Task Example":"Новый пример задания",
    "Move up":"Переместить вверх",
    "Move down":"Переместить вниз",
    "Delete task example":"Удалить пример задания",
    "You are not allowed to access this section.":"У вас нет доступа к этому разделу.",
    "Email":"Электронная почта",
    "Group":"Группа",
    "Subgroup":"Подгруппа",
    "Timestamp":"Отметка времени",
    "Add new FAQ":"Добавить новую часто задаваемый вопрос (FAQ)",
    "Enter a title":"Введите заголовок",
    "Weight":"Вес",
    "Enter a weigh":"Введите вес",
    "Delete FAQ":"Удалить FAQ",
    "You are about to delete FAQ content":"Вы собираетесь удалить контент FAQ",
    "Edit FAQ":"Редактировать FAQ",
    "Body":"Основной текст",
    "No FAQ selected.":"Не выбрано FAQ.",
    "New FAQ":"Новое FAQ",
    "Delete feedback":"Удалить отзыв",
    "You are about to delete feedback content":"Вы собираетесь удалить контент отзыва",
    "Feedback management":"Управление отзывами",
    "Issue":"Проблема",
    "Section":"Раздел",
    "Date":"Дата",
    "User":"Пользователь",
    "Add new help":"Добавить новую справку",
    "Help items":"Элементы справки",
    "There are no help items defined. Add your first help item.":"Нет определенных элементов справки. Добавьте свой первый элемент справки.",
    "Edit help":"Редактировать справку",
    "Delete user":"Удалить пользователя",
    "Add help item":"Добавить элемент справки",
    "Teaser":"Краткое описание",
    "More link":" *****",
    "Text for the more link":"****",
    "Enter the title":"Введите заголовок",
    "Examples":"Примеры",
    "References":"Ссылки",
    "Modify":"Изменить",
    "Delete help":"Удалить справку",
    "You are about to delete help content":"Вы собираетесь удалить контент справки",
    "Enter a descriptive name":"Введите описательное название",
    "Help item":"Элемент справки",
    "Enter the position of this help content relative to other help contents. The higher the value the lower it will be sorted.":"Введите позицию этого элемента справки относительно других. Чем выше значение, тем ниже он будет отсортирован.",
    "Edit Help Item":"Редактировать элемент справки",
    "Are you sure you want to delete Help Item named?":"Вы уверены, что хотите удалить элемент справки с названием",
    "No help selected.":"Элемент справки не выбран.",
    "Help management":"Управление справкой",
    "New help":"Новая справка",
    "Add new organization":"Добавить новую организацию",
    "Delete organization":"Удалить организацию",
    "You are about to delete organization content":"Вы собираетесь удалить контент организации",
    "Edit Organization":"Редактировать организацию",
    "Organizations management":"Управление организациями",
    "New organization":"Новая организация",
    "Edit organizataion":"Редактировать организацию",
    "You must generate a password for the user. Use the button below.":"Вы должны создать пароль для пользователя. Используйте кнопку ниже.",
    "You must give the user a role.":"Вы должны назначить пользователю роль.",
    "Email address":"Адрес электронной почты",
    "Password":"Пароль",
    "Student":"Студент",
    "Teacher":"Учитель",
    "Administrator":"Администратор",
    "Lastname":"Фамилия",
    "Write the name of the user":"Введите имя пользователя",
    "Write the lastname of the user":"Введите фамилию пользователя",
    "- Select an organization -":"- Выберите организацию -",
    "Generate password":"Создать пароль",
    "You are about to delete user with email":"Вы собираетесь удалить пользователя с адресом электронной почты",
    "All user data and tasks will be deleted. This action cannot be undone.":"Все данные пользователя и задания будут удалены. Это действие нельзя отменить.",
    "You must generate or write a password for the user. Use the button below.":"Вы должны создать или ввести пароль для пользователя. Используйте кнопку ниже.",
    "Users management":"Управление пользователями",
    "New user":"Новый пользователь",
    "Mail":"Почта",
    "Organization":"Организация",
    "Role":"Роль",
    "Edit user":"Редактировать пользователя",
    "Only MP4 videos are allowed.":"Разрешены только видео в формате MP4.",
    "Add new Video":"Добавить новое видео",
    "Delete Video":"Удалить видео",
    "You are about to delete Video content":"Вы собираетесь удалить контент видео",
    "Edit Video":"Редактировать видео",
    "No Video selected.":"Видео не выбрано.",
    "Video management":"Управление видео",
    "New Video":"Новое видео",
    "Beginnings are always difficult":"Начала всегда трудны",
    "Do not hesitate to contact us with any questions you may have.":"Не стесняйтесь связаться с нами, если у вас есть какие-либо вопросы.",
    "Contact us":"Свяжитесь с нами",
    "Check out some of the questions teachers/designers have asked us so far. The answers will help you to get the most of the tool":"Ознакомьтесь с некоторыми вопросами, которые задавали учителя/разработчики заданий. Ответы помогут вам лучше использовать приложение.",
    "Dashboard":"Главная панель",
    "Tasks":"Задания",
    "Pretasks":"Пре-задания",
    "Postasks":"Пост-задания",
    "Task groups":"Группы заданий",
    "Task roles":"Роли задания",
    "Task prompts":"Набор инструкции к заданию",
    "Text analyzer":"Анализатор текста",
    "Help system":"Система помощи",
    "What is <span>taskGen</span>?":"Что такое <span>taskGen</span>?",
    "It is an ongoing three-year research project made possible by a grant PID2023-149648NB-I00 funded by the Ministry of Science and Innovation (MCIN) and National Research Agency (AEI) 10.13039/501100011033.":"Это трехлетний исследовательский проект, финансируемый грантом PID2023-149648NB-I00 Министерства науки и инноваций (MCIN) и Национального агентства исследований (AEI) 10.13039/501100011033.",
    "In this project we are developing and piloting a tool that will help teachers and task and syllabus designers with organizing and automating the design of second/foreign language communicative tasks. If you wish to know more about the project, please click here...":"В рамках этого проекта мы разрабатываем и тестируем приложение, который поможет учителям и разработчикам заданий и учебных программ в организации и автоматизации создания коммуникативных заданий по изучению второго/иностранного языков. Если вы хотите узнать больше о проекте, нажмите здесь...",
    "Read more":"Подробнее",
    "The task has been cloned. You will find the cloned task in \"My Task designs\" in the dashboard":"Задача была клонирована. Вы найдете клонированную задачу в \"Мои проекты задач\" на главной панели.",
    "Wish to design a task?":"Хотите создать задание?",
    "or get some inspiration":"или получить вдохновение",
    "See some examples":"Посмотрите несколько примеров",
    "Create a new task":"Создать новое задание",
    "Shared directly with me":"Доступ к заданию предоставлен непосредственно мне пользователем",
    "Task examples":"Примеры заданий",
    "Cathoven will automatically detect the CEFR level of the text you insert in their text box (up to 250 words if you want to do it for free). You can also generate exercises automatically. You generate new texts if you insert a topic. You can copy and paste your classified texts into the taskGen textbox and use the button \"Analyze\" to get a complete linguistic analysis of your text. Then you can select some linguistic feature that are relevant to your task":"Cathoven автоматически определяет уровень CEFR текста, который вы вставляете в их текстовое поле (до 250 слов, если вы используете бесплатный режим). Вы также можете генерировать упражнения автоматически. Вы можете создавать новые тексты, если вводите тему. Вы можете скопировать и вставить свои классифицированные тексты в текстовое поле taskGen и нажать кнопку \"Анализ\", чтобы получить полный лингвистический анализ вашего текста. Затем вы можете выбрать некоторые лингвистические особенности, которые важны для вашей задачи",
    "You can get some inspiration about possible pre-tasks in the International Task Bank where you can obtain and download full task designs.":"Вы можете найти идеи для возможных пре-заданий в Международном банке заданий, где можно получить и скачать готовые проекты заданий.",
    "Quizlet is a tool that allows students to learn vocabulary by means of customised flashcards":"Quizlet — это инструмент, который позволяет студентам учить словарь с помощью персонализированных флеш-карточек",
    "If you are in primary or secondary, here's a list of AI tools you can use to assist your teaching. Signing up and using the tools is free. You can bring the outcomes of those tools and cut and paste them into the taskGen textbox.":"Если вы работаете в начальной или средней школе, вот список инструментов ИИ, которые вы можете использовать для поддержки преподавания. Регистрация и использование инструментов бесплатны. Вы можете переносить результаты этих инструментов и вставлять их в текстовое поле taskGen.",
    "edpuzzle will let you create interactive videos where questions appear as they watch the video. You can include the link to the edpuzzle video in the taskGen text box.":"Edpuzzle позволит вам создавать интерактивные видео, в которых вопросы появляются во время просмотра видео. Вы можете включить ссылку на видео edpuzzle в текстовое поле taskGen.",
    "The program can generate videos on the basis of the topic you choose. You have limited access as a free user. You can also insert the link in taskGen or upload the audio files you create with these apps.":"Программа может генерировать видео на основе выбранной вами темы. У вас ограниченный доступ как у бесплатного пользователя. Вы также можете вставить ссылку в taskGen или загрузить аудиофайлы, созданные с помощью этих приложений.",
    "You can insert a text and have the program read the text for you. You have limited access as a free user.":"Вы можете вставить текст, и программа прочитает его для вас. У вас ограниченный доступ как у бесплатного пользователя.",
    "Quizbot will let you transform an audio file into text and then generate questions. You can copy and paste the question into the taskGen text box. You can also insert the link in taskGen or upload the audio files you create with these apps.":"Quizbot позволит вам преобразовать аудиофайл в текст, а затем сгенерировать вопросы. Вы можете скопировать и вставить вопросы в текстовое поле taskGen. Вы также можете вставить ссылку в taskGen или загрузить аудиофайлы, созданные с помощью этих приложений.",
    "Two classic web sites where you can find movie scripts and scripts from TV series.":"Два классических сайта, где можно найти сценарии фильмов и сценарии телесериалов.",
    "Use this tool to generate a dialogue. Just describe your objective and a bit of a context, and it’ll give you a perfectly crafted dialogue for you. You can copy and paste the dialogues into the taskGen text box. Then you can use the function “Analyze” to get a complete analysis of the linguistic features of the text. You can automatically highlight and or change font size to bring attention to those features (input enhancement)":"Используйте этот инструмент для генерации диалога. Просто опишите свою цель и немного контекста, и он предоставит вам идеально составленный диалог. Вы можете скопировать и вставить диалоги в текстовое поле taskGen. Затем вы можете использовать функцию «Анализ», чтобы получить полный анализ лингвистических особенностей текста. Вы можете автоматически выделять и изменять размер шрифта, чтобы обратить внимание на эти особенности (усиление входного материала)",
    "You can generate new pictures.":"Вы можете сгенерировать новые изображения.",
    "You can upload a picture and the program will generate questions about the picture automatically.":"Вы можете загрузить изображение, и программа автоматически сгенерирует вопросы об этом изображении.",
    "You can use this tool to have a text be read by a computerized voice.":"Вы можете использовать этот инструмент, чтобы текст читался компьютерным голосом.",
    "You can insert a text and have the program read the text for you. You have limited access as a free user. You can copy the link in the taskGen text box or upload the audio file onto to your speech transcript pre-task.":"Вы можете вставить текст, и программа прочитает его для вас. У вас ограниченный доступ как у бесплатного пользователя. Вы можете скопировать ссылку в текстовое поле taskGen или загрузить аудиофайл в пре-задание \"Расшифровка речи\".",
    "You can get ideas and example about interaction activities in the International Task Bank.":"Вы можете получить идеи и примеры интерактивных упражнений в Международном банке заданий.",
    "Use this tool to generate a dialogue. Just describe your objective and a bit of a context, and it’ll give you a perfectly crafted dialogue for you.":"Используйте этот инструмент для генерации диалога. Просто опишите свою цель и немного контекста, и он предоставит вам идеально составленный диалог.",
    "AI Tools and other resources":"Инструменты ИИ и другие ресурсы",
    "Sorry! The result of the text analysis is either empty or some errors were found. Revise and change your text and try it again.":"Извините! Результат анализа текста либо пуст, либо были найдены ошибки. Проверьте и измените текст, затем попробуйте снова.",
    "Pragmatic Expressions":"Pragmatic Expressions",
    "All pragmatic expressions":"All pragmatic expressions",
    "Suggesting":"Suggesting",
    "Thanking":"Thanking",
    "Requesting":"Requesting",
    "Agreeing/Disagreeing":"Agreeing/Disagreeing",
    "Showing interest":"Showing interest",
    "Apologising":"Apologising",
    "Giving an opinion":"Giving an opinion",
    "Greeting":"Greeting",
    "Phrasal verbs":"Phrasal verbs",
    "Word Categories":"Категории слов",
    "Nouns":"Nouns",
    "All nouns":"All nouns",
    "Irregular plurals":"Irregular plurals",
    "Adjectives":"Прилагательные",
    "All adjectives":"Все прилагательные",
    "Comparative adjectives":"Comparative adjectives",
    "Superlative adjectives":"Superlative adjectives",
    "Adverbs":"Наречия",
    "All adverbs":"Все наречия",
    "Comparative adverbs":"Comparative adverbs",
    "Superlative adverbs":"Superlative adverbs",
    "Wh-adverb":"Wh-adverb",
    "Verbs":"Глаголы",
    "Irregular verbs":"Irregular verbs",
    "Verb Tense":"Verb Tense",
    "Active":"Active",
    "Present Simple":"Present Simple",
    "Present Perfect":"Present Perfect",
    "Present Perfect Continuous":"Present Perfect Continuous",
    "Past Simple":"Past Simple",
    "Past Continuous":"Past Continuous",
    "Past Perfect":"Past Perfect",
    "Past Perfect Continuous":"Past Perfect Continuous",
    "Future ‘going to’":"Future ‘going to’",
    "Future Simple":"Future Simple",
    "Future Perfect":"Future Perfect",
    "Future Perfect Continuous":"Future Perfect Continuous",
    "Passive":"Passive",
    "Present Simple Passive":"Present Simple Passive",
    "Present Continuous Passive":"Present Continuous Passive",
    "Present Perfect Passive":"Present Perfect Passive",
    "Present Perfect Continuous Passive":"Present Perfect Continuous Passive",
    "Past Simple Passive":"Past Simple Passive",
    "Past Continuous Passive":"Past Continuous Passive",
    "Past Perfect Passive":"Past Perfect Passive",
    "Past Perfect Continuous Passive":"Past Perfect Continuous Passive",
    "Future Simple Passive":"Future Simple Passive",
    "Future Perfect Passive":"Future Perfect Passive",
    "Modal Verbs":"Modal Verbs",
    "Imperative":"Imperative",
    "Prepositions":"Предлоги",
    "Determiners":"Determiners",
    "All determiners":"All determiners",
    "Determiner":"Determiner",
    "Wh-Determiner":"Wh-Determiner",
    "Wh-pronouns":"Wh-pronouns",
    "Possessive wh-pronoun":"Possessive wh-pronoun",
    "Possessive Pronouns":"Possessive Pronouns",
    "Coordinating Conjunctions":"Coordinating Conjunctions",
    "Clone as PosT-task":"Дублировать как пост-задание",
    "Clone as Pre-task":"Дублировать как пре-задание",
    "We are sorry! There was a processing error. Text Analysis is out of order at this moment. Give us some time to recover and try again later.":"Нам очень жаль! Произошла ошибка обработки. Анализ текста временно недоступен. Подождите немного, чтобы восстановиться, и попробуйте позже.",
    "hour":"час",
    "hours":"часа",
    "minute":"минута",
    "minutes":"минуты",
    "second":"секунда",
    "seconds":"секунды",
    "Previously formatted text":"Ранее отформатированный текст",
    "Important":"Важно",
    "The tool is still under construction, but give it a try! We\'re working on it.":"Инструмент все еще находится на стадии разработки, но попробуйте! Мы работаем над этим.",
    "processing":"Обработка...",
    "Analyze the text":"Проанализировать текст",
    "Text analyzed in":"Текст проанализирован за",
    "Analysis language": "Язык анализа",
    "The text will be analyzed in": "Текст будет проанализирован на",
    "To change the analysis language, modify the task language in the task metadata section": "Чтобы изменить язык анализа, измените язык задания в разделе метаданных задания",
    "read more...":"Подробнее...",
    "Drag and Drop files here":"Перетащите файлы сюда",
    "Click on the plus icon of each user you want to select:":"Нажмите на значок плюса каждого пользователя, которого хотите выбрать:",
    "Users selected:":"Пользователи выбраны:",
    "Users Groups":"Группы пользователей",
    "Organizations":"Организации",
    "Help":"Справка / помощь",
    "FAQs":"Часто задаваемые вопросы",
    "Feedbacks":"Отзывы",
    "Help index":"Индекс справки",
    "Video tutorials":"Видеоруководства",
    "To describe an object, person or place":"Описать объект, человека или место",
    "To solve a communication problem or gap":"Решить коммуникационную проблему или пробел",
    "To create a design or plan":"Создать дизайн или план",
    "To to make a decision or choice":"Принять решение или сделать выбор",
    "To explain a process":"Объяснить процесс",
    "To tell a story":"Рассказать историю",
    "To reach an agreement":"Достигнуть соглашения",
    "To learn new content (focus on meaning)":"Изучить новое содержание (фокус на смысле)",
    "To fill out a form":"Заполнить форму",
    "To make a complaint":"Сделать жалобу",
    "To request information":"Запросить информацию",
    "To formulate an argument":"Сформулировать аргумент",
    "To express an opinion":"Выразить мнение",
    "To foster critical language awareness":"Развивать критическое языковое осознание",
    "A1 Movers":"A1 / Элементарный уровень",
    "A2 Key":"A2 / Базовый уровень",
    "B1 Preliminary":"B1 / ТРКИ-1",
    "B2 First":"B2 / ТРКИ-2",
    "C1 Advanced":"C1 / ТРКИ-3",
    "C2 Proficiency":"C2 / ТРКИ-4",
    "Edit Post-Task: Audio":"Редактировать пост-задание: Аудио",
    "Title of the Post-Task":"Название пост-задания",
    "Teacher notes":"Заметки учителя",
    "Edit Post-Task: Written Dialogue":"Редактировать пост-задание: Письменный диалог",
    "Edit Post-Task: Exercises":"Редактировать пост-задание: Упражнения",
    "Edit Post-Task: Explicit Explanation":"Редактировать пост-задание: Явное объяснение",
    "Edit Post-Task: Game":"Редактировать пост-задание: Игра",
    "Edit Post-Task: Interaction Activity":"Редактировать пост-задание: Интерактивное упражнение",
    "Edit Post-Task: Photo":"Редактировать пост-задание: Фото",
    "Edit Post-Task: Repetition":"Редактировать пост-задание: Повторение",
    "Edit Post-Task: Written to Oral / Oral to Written":"Редактировать пост-задание: Письменная форма в устную / Устная форма в письменную",
    "Edit Post-Task: Teacher Feedback":"Редактировать пост-задание: Обратная связь учителя",
    "Edit Post-Task: Text":"Редактировать пост-задание: Текст",
    "Edit Post-Task: Task model and exercises":"Редактировать пост-задание: Модель задания и упражнения",
    "Edit Post-Task: Video":"Редактировать пост-задание: Видео",
    "New Post-Task: Audio":"Новое пост-задание: Аудио",
    "New Post-Task: Written Dialogue":"Новое пост-задание: Письменный диалог",
    "New Post-Task: Exercises":"Новое пост-задание: Упражнения",
    "New Post-Task: Explicit Explanation":"Новое пост-задание: Явное объяснение",
    "New Post-Task: Game":"Новое пост-задание: Игра",
    "New Post-Task: Interaction Activity":"Новое пост-задание: Интерактивное упражнение",
    "New Post-Task: Photo":"Новое пост-задание: Фото",
    "New Post-Task: Repetition":"Новое пост-задание: Повторение",
    "New Post-Task: Written to Oral / Oral to Written":"Новое пост-задание: Письменная форма в устную / Устная форма в письменную",
    "New Post-Task: Teacher Feedback":"Новое пост-задание: Обратная связь учителя",
    "New Post-Task: Text":"Новое пост-задание: Текст",
    "New Post-Task: Task model and exercises":"Новое пост-задание: Модель задания и упражнения",
    "New Post-Task: Video":"Новое пост-задание: Видео",
    "Resource":"Ресурс",
    "This post-task has no text":"У этого пост-заданий нет текста",
    "Edit Pre-Task: Interaction activity":"Редактировать пре-задание: Интерактивное упражнение",
    "Title of the Pre-Task":"Название пре-заданий",
    "Edit Pre-Task: Audio":"Редактировать пре-задание: Аудио",
    "Edit Pre-Task: Written Dialogue":"Редактировать пре-задание: Письменный диалог",
    "Edit Pre-Task: Game":"Редактировать пре-задание: Игра",
    "Edit Pre-Task: Photo":"Редактировать пре-задание: Фото",
    "Edit Pre-Task: Speech transcript":"Редактировать пре-задание: Расшифровка речи",
    "Edit Pre-Task: Text":"Редактировать пре-задание: Текст",
    "Edit Pre-Task: Video":"Редактировать пре-задание: Видео",
    "Edit Pre-Task: Warm-up":"Редактировать пре-задание: Разминка",
    "New Pre-Task: Interaction activity":"Новое пре-задание: Интерактивное упражнение",
    "New Pre-Task: Audio":"Новое пре-задание: Аудио",
    "New Pre-Task: Written Dialogue":"Новое пре-задание: Письменный диалог",
    "New Pre-Task: Game":"Новое пре-задание: Игра",
    "New Pre-Task: Photo":"Новое пре-задание: Фото",
    "New Pre-Task: Speech transcript":"Новое пре-задание: Расшифровка речи",
    "New Pre-Task: Text":"Новое пре-задание: Текст",
    "New Pre-Task: Video":"Новое пре-задание: Видео",
    "New Pre-Task: Warm-up":"Новое пре-задание: Разминка",
    "No text specified for this pre-task":"Для этого пре-задания не указан текст",
    "Prompt":"Prompt",
    "(copy)":"(копировать)",
    "Edit Main Task":"Редактировать основное задание",
    "Add new role":"Добавить новую роль",
    "Add new prompt":"Добавить новую роль",
    "There are no groups":"Нет групп",
    "There are no roles":"Нет ролей",
    "There are no prompts defined":"Нет определенных наборов инструкции к заданию",
    "This prompt has no text":"В этом Наборе инструкции к заданию нет текста",
    "Belongs to groups":"Входит в группы",
    "Are you sure you want to delete the student? This action cannot be undone.":"Вы уверены, что хотите удалить студента? Это действие нельзя отменить.",
    "Edit student":"Редактировать студента",
    "Delete student":"Удалить студента",
    "- Select a role -":"Выберите роль",
    "- Select a prompt -":"Выберите Набор инструкции к заданию",
    "Are you sure you want to delete the group? This action cannot be undone.":"Вы уверены, что хотите удалить группу? Это действие нельзя отменить.",
    "Change color":"Изменить цвет",
    "Add new student":"Добавить нового студента",
    "Edit name":"Редактировать имя",
    "Clone":"Дублировать",
    "Title of the Prompt":"Название Набора инструкции к заданию",
    "Are you sure you want to delete the prompt? This action cannot be undone.":"Вы уверены, что хотите удалить Набор инструкции к заданию? Это действие нельзя отменить.",
    "Clone prompt":"Дублировать Набор инструкции к заданию",
    "Edit prompt":"Редактировать Набор инструкции к заданию",
    "Delete prompt":"Удалить Набор инструкции к заданию",
    "Are you sure you want to delete the role? This action cannot be undone.":"Вы уверены, что хотите удалить роль? Это действие нельзя отменить.",
    "Assignments for the role:":"Назначения для роли:",
    "Select the groups this role is assigned to":"Выберите группы, которым назначена эта роль",
    "Groups":"Группы",
    "Roles":"Роли",
    "Prompts":"Наборы инструкции к заданию",
    "Clone task":"Дублировать задание",
    "Edit task":"Редактировать задание",
    "Are you sure you want to delete?":"Вы уверены, что хотите удалить",
    "Do you want to add the task":"Вы хотите добавить задание",
    "Pre-Task has been clonned as a Pos-Task.":"пре-задание было дублировано как пост-задание.",
    "Are you sure you want to delete the pre-task?":"Вы уверены, что хотите удалить пред-задания",
    "My task designs": "Мои проекты заданий",
    "Shared with me": "Поделились со мной",
    "Interface language": "IЯзык интерфейса",
    "Log out": "Выйти",
    "User groups": "Группы пользователей",
    "Feedback": "Feedback",
    "Where do you usually teach?": "Где вы обычно преподаете?",
    "How do you typically teach?": "Как вы обычно преподаете?",
    "What's your general teaching framework?": "Какова ваша общая структура преподавания?",
    "Russian analyzer not available yet":"Анализатор русского языка пока недоступен",
    "The Russian text analyzer is not available yet, but it will be soon. We are working on it!":"Анализатор текста на русском языке пока недоступен, но скоро будет. Мы работаем над этим!",
    "The taskGen team<br />University of Barcelona":"команда TaskGen<br />Университет Барселоны",
    "- Select a proficiency level -":"- Выберите уровень квалификации -",
    "- Select a session -":"– Выберите занятие –",
    "- Select a tag -":"- Выберите метку -",
    "- Select an aim -":"- Выберите цель -",
    "@":"@",
    "Add":"Добавить",
    "All pronouns":"Все местоимения",
    "Are you sure you want to delete this section? Tasks in this section will be moved to 'Unsectioned'.":"Вы уверены, что хотите удалить эту категорию? Задания в этой категории будут сохранены в 'Категория не назначена'.",
    "Are you sure you want to delete this tag? This action cannot be undone.":"Вы уверены, что хотите удалить этот тег? Это действие нельзя отменить.",
    "Clone as Pos-task":"Клонировать как постзадание",
    "Create":"Создать",
    "Create Section":"Создать категорию",
    "Create a new section":"Создайте новую категорию",
    "DD/MM/YYYY":"ДД/ММ/ГГГГ",
    "DD/MM/YYYY hh:mm":"ДД/ММ/ГГГГ чч:мм",
    "Delete section":"Удалить категорию",
    "Discard":"Выбросить",
    "Download DOCX":"Скачать DOCX",
    "Downloading...":"Загрузка...",
    "Edit Section":"Редактировать категорию",
    "Edit section":"Редактировать категорию",
    "Enter section name":"Введите название категории",
    "Go back":"Вернуться",
    "If you accept, you will find this task in the 'Shared with me' section. From there you will be able to clone it and create your own version of the task.":"Если вы согласитесь, то найдете это задание в вкладке 'Поделился со мной'. Оттуда вы сможете клонировать его и создать свою собственную версию задания.",
    "If you are in primary or secondary, here's a list of AI tools you can use to assist your teaching. Signing up and using the tools is free.<br /> You can bring the outcomes of those tools and cut and paste them into the taskGen textbox.":"Если вы работаете в начальной или средней школе, вот список инструментов искусственного интеллекта, которые вы можете использовать для преподавания. Регистрация и использование инструментов бесплатны.<br /> Вы можете взять результаты работы этих инструментов и вырезать и вставить их в текстовое поле TaskGen.",
    "If you have any questions, you can contact the taskGen team at<br />taskgenproject@gmail.com":"Если у вас возникли вопросы, вы можете связаться с командой taskGen по адресу<br />taskgenproject@gmail.com",
    "Language":"Язык",
    "Log in using your email":"Войдите в систему, используя свою электронную почту",
    "Login or register":"Войти или зарегистрироваться",
    "No prompt assigned":"Запрос не назначен",
    "No role assigned":"Роль не назначена",
    "No tasks in this section":"В этой категории нет заданий",
    "No user selected.":"Пользователь не выбран.",
    "Not translated":"Не переведено",
    "Number of students":"Количество студентов",
    "Pos-task":"постзадание",
    "Pre-task":"предзадание",
    "Print":"Печать",
    "Pronouns":"Местоимения",
    "Quizbot will let you <strong>transform an audio file into text</strong> and then <strong>generate questions</strong>.<br /> You can copy and paste the question into the taskGen text box. You can also insert the link in taskGen or upload the audio files you create with these apps.":"Quizbot позволит вам <strong>преобразовать аудиофайл в текст</strong>, а затем <strong>сгенерировать вопросы</strong>.<br /> Вы можете скопировать и вставить вопрос в текстовое поле taskGen. Вы также можете вставить ссылку в taskGen или загрузить аудиофайлы, созданные с помощью этих приложений.",
    "Section Name":"Название категории",
    "Select the groups you want to <strong>share the task</strong>:":"Выберите группы, с которыми вы хотите <strong>совместно выполнять задание</strong>:",
    "Select the users with whom you want to <strong>share the task</strong>:":"Выберите пользователей, с которыми вы хотите <strong>поделиться заданием</strong>:",
    "Students":"Студенты",
    "Tags":"Теги",
    "Task":"Задание",
    "Teachers":"Учителя",
    "Thanks for your feedback.":"Спасибо за ваш отзыв.",
    "The program can <strong>generate videos</strong> on the basis of the topic you choose. You have limited access as a free user.<br /> You can also insert the link in taskGen or upload the audio files you create with these apps.":"Программа может <strong>генерировать видеоролики</strong> на основе выбранной вами темы. У вас ограниченный доступ как у бесплатного пользователя.<br /> Вы также можете вставить ссылку в taskGen или загрузить аудиофайлы, созданные с помощью этих приложений.",
    "There are no post-tasks defined":"постзадания не определены",
    "There are no prompts":"Нет никаких запросов",
    "There are no tasks defined":"Задания не определены",
    "There was a problem uploading files. You can upload a maximum of 5 files simultaneously and not more than 50MB. Try reducing file sizes or uploading fewer files simultaneously. If the problem persists, contact us.":"Возникла проблема с загрузкой файлов. Вы можете одновременно загружать не более 5 файлов и не более 50 МБ. Попробуйте уменьшить размер файлов или загружать меньше файлов одновременно. Если проблема сохраняется, свяжитесь с нами.",
    "This tag already exists.":"Этот тег уже существует.",
    "To use this link, you must have a TaskGen account. Go to the login page and access with your account or register.":"Чтобы воспользоваться этой ссылкой, у вас должна быть учетная запись TaskGen. Перейдите на страницу входа и войдите в систему под своей учетной записью или зарегистрируйтесь.",
    "Translations":"Переводы",
    "Two classic web sites where you can <strong>find movie scripts</strong> and scripts from <strong>TV series</strong>.":"Два классических сайта, на которых можно <strong>найти сценарии фильмов</strong> и сценарии <strong>телесериалов</strong>.",
    "Unsectioned":"Категория не назначена",
    "Use this tool to <strong>generate a dialogue</strong>. Just describe your objective and a bit of a context, and it’ll give you a perfectly crafted dialogue for you.":"Используйте этот инструмент для <strong>создания диалога</strong>. Опишите свою цель и приведите контекста, и он выдаст вам идеально составленный диалог.",
    "Use this tool to <strong>generate a dialogue</strong>. Just describe your objective and a bit of a context, and it'll give you a perfectly crafted dialogue for you.<br /> You can copy and paste the dialogues into the taskGen text box. Then you can use the function \"Analyze\" to get a complete analysis of the linguistic features of the text. You can automatically highlight and or change font size to bring attention to those features (input enhancement)":"Используйте этот инструмент для <strong>создания диалога</strong>. Опишите свою цель и приведите контекста, и он выдаст вам идеально составленный диалог. для получения полного анализа лингвистических особенностей текста. Вы можете автоматически выделять и/или изменять размер шрифта, чтобы привлечь внимание к этим особенностям (input enhancement).",
    "We are working to improve the Taskgen site.":"Мы работаем над улучшением сайта Taskgen.",
    "Write a tag name":"Напишите название тега",
    "Write your mail address and we\'ll send you an email with instructions to finish your registration.":"Напишите свой почтовый адрес, и мы отправим вам письмо с инструкциями по завершению регистрации.",
    "YYYY-MM-DD":"ГГГГ-ММ-ДД",
    "YYYY-MM-DD hh:mm:ss":"ГГГГ-ММ-ДД чч:мм:сс",
    "YYYYMMDD":"ГГГГММДД",
    "You can <strong>generate new pictures</strong>.":"Вы можете <strong>создавать новые изображения</strong>.",
    "You can <strong>get ideas</strong> and example about interaction activities in the International Task Bank.":"<strong>Идеи</strong> и примеры взаимодействия можно <strong>почерпнуть</strong> в Международном банке заданий.",
    "You can add users of your organization or any user in taskGen.":"Вы можете добавить пользователей своей организации или любого пользователя в taskGen.",
    "You can insert a text and have the program <strong>read the text for you</strong>. You have limited access as a free user.":"Вы можете вставить текст и попросить программу <strong>прочитать его за вас</strong>. У вас ограниченный доступ как у бесплатного пользователя.",
    "You can insert a text and have the program <strong>read the text for you</strong>. You have limited access as a free user. You can copy the link in the taskGen text box or upload the audio file onto to your speech transcript pre-task.":"Вы можете вставить текст и попросить программу <strong>прочитать его за вас</strong>. У вас ограниченный доступ как у бесплатного пользователя. Вы можете скопировать ссылку в текстовое поле taskGen или загрузить аудиофайл в предварительное задание по расшифровке речи.",
    "You can upload a picture and the program will <strong>generate questions</strong> about the picture automatically.":"Вы можете загрузить фотографию, и программа автоматически <strong>сгенерирует вопросы</strong> по ней.",
    "You can use this tool to <strong>have a text be read</strong> by a computerized voice.":"С помощью этого инструмента можно <strong>заставить</strong> компьютерный голос <strong>прочитать текст</strong>.",
    "[video ":"[video ",
    "[video=":"[video=",
    "a":"a",
    "edpuzzle will let you <strong>create interactive videos</strong> where questions appear as they watch the video. You can include the link to the edpuzzle video in the taskGen text box.":"edpuzzle позволяет <strong>создавать интерактивные видеоролики</strong>, в которых вопросы появляются по мере просмотра видео. Вы можете включить ссылку на видео edpuzzle в текстовое поле taskGen.",
    "not used":"не используется",
    "students":"студенты",
    "used by":"используемый пользователем",
    "Search":"Поиск",
    "Search in all fields...":"Поиск во всех полях...",
    "Searching...":"Поиск...",
    "Sort by":"Сортировать по",
    "Clear filters":"Очистить фильтры",
    "Total results":"Всего результатов",
    "Searching for":"Поиск",
    "Filters":"Фильтры",
    "Rows per page":"Строк на странице",
    "of":"из",
    "Clear":"Очистить",
    "Search by email, username, name, organization...":"Поиск по email, имени пользователя, имени, организации...",
    "Search by organization name...":"Поиск по названию организации...",
    "New version available":"Доступна новая версия",
    "Version":"Версия",
    "is available. Reload to update.":"доступна. Перезагрузите для обновления.",
    "Reload":"Перезагрузить",
    "Later":"Позже",
    "Translate with DeepL":"Перевести с помощью DeepL",
    "Translating...":"Перевод...",
    "Please enter text to translate":"Пожалуйста, введите текст для перевода",
    "Cannot translate to English (source language)":"Невозможно перевести на английский (исходный язык)",
    "Please enter English title first":"Пожалуйста, сначала введите заголовок на английском",
    "Please enter English body first":"Пожалуйста, сначала введите текст на английском",
    "Translation error: ":"Ошибка перевода: ",
    "You can add translations to other languages after creating the FAQ.":"Вы можете добавить переводы на другие языки после создания FAQ.",
    "DeepL does not support Catalan":"DeepL не поддерживает каталанский",
    "Please enter English teaser first":"Пожалуйста, сначала введите тизер на английском",
    "Please enter English examples first":"Пожалуйста, сначала введите примеры на английском",
    "Please enter English references first":"Пожалуйста, сначала введите ссылки на английском",
    "Export User Events":"Экспорт событий пользователей",
    "Export Users":"Экспорт пользователей",
    "Export Tasks":"Экспорт задания",
    "Export Tasks Groups":"Экспорт групп заданий",
    "Export NLP Events":"Экспорт событий NLP",
    "Action":"Действие",
    "Reference":"Ссылка",
    "Start":"Начало",
    "End":"Конец",
    "Start date":"Дата начала",
    "End date":"Дата окончания",
    "Duration":"Продолжительность",
    "Teaching location":"Место обучения",
    "Teaching model":"Модель обучения",
    "Teaching framework":"Структура обучения",
    "Teaching years":"Годы обучения",
    "User ID":"ID пользователя",
    "Number of pre-tasks":"Количество предзаданий",
    "Number of subtasks":"Количество подзаданий",
    "Number of post-tasks":"Количество постзаданий",
    "Number of sessions":"Количество занятий",
    "Cloned":"Дублировано",
    "Original source":"Исходный источник",
    "Original task":"Исходное задание",
    "Task name":"Название задания",
    "Subtask name":"Название под-задания",
    "Number of members":"ККоличество участников",
    "Add new Feedback":"Добавить новый отзыв",
    "Select the functionality of the application about which you want to comment":"Выберите функциональность приложения, о которой хотите оставить комментарий",
    "Subject":"Тема",
    "Write the subject of your comment":"Напишите тему вашего комментария",
    "Comment":"Комментарий",
    "Leave your comments here":"Оставьте ваши комментарии здесь",
    "ID":"ID",
    "Country":"Страна",
    "Region":"Регион",
    "Level":"Уровень",
    "Proficiency level":"Уровень владения",
    "Option":"Вариант",
    "Common nouns":"Нарицательные существительные",
    "All common nouns":"Все нарицательные существительные",
    "Feminine nouns":"Женский род",
    "Masculine nouns":"Мужской род",
    "Neuter nouns":"Средний род",
    "Animacy":"Одушевлённость",
    "Animate nouns":"Одушевлённые существительные",
    "Inanimate nouns":"Неодушевлённые существительные",
    "Singular nouns":"Единственное число",
    "Plural nouns":"Множественное число",
    "Nominative case":"Именительный падеж",
    "Genitive case":"Родительный падеж",
    "Accusative case":"Винительный падеж",
    "Dative case":"Дательный падеж",
    "Instrumental case":"Творительный падеж",
    "Prepositional case":"Предложный падеж",
    "Proper nouns":"Имена собственные",
    "All proper nouns":"Все имена собственные",
    "Feminine proper nouns":"Женские имена собственные",
    "Masculine proper nouns":"Мужские имена собственные",
    "Neuter proper nouns":"Средние имена собственные",
    "Animate proper nouns":"Одушевлённые имена собственные",
    "Inanimate proper nouns":"Неодушевлённые имена собственные",
    "Singular proper nouns":"Единственное число",
    "Plural proper nouns":"Множественное число",
    "All Pronouns":"Все местоимения",
    "Feminine pronouns":"Женский род",
    "Masculine pronouns":"Мужской род",
    "Neuter pronouns":"Средний род",
    "Animate pronouns":"Одушевлённые местоимения",
    "Inanimate pronouns":"Неодушевлённые местоимения",
    "Singular pronouns":"Единственное число",
    "Plural pronouns":"Множественное число",
    "Person":"Лицо",
    "First person pronouns":"Местоимения 1-го лица",
    "Second person pronouns":"Местоимения 2-го лица",
    "Third person pronouns":"Местоимения 3-го лица",
    "Pronoun Type":"Тип местоимений",
    "Personal pronouns":"Личные местоимения",
    "Indefinite pronouns":"Неопределённые местоимения",
    "Demonstrative pronouns (PronType=Dem)":"Указательные местоимения",
    "Interrogative/Relative pronouns (PronType=Int,Rel)":"Вопросительные местоимения",
    "Total pronouns (PronType=Tot)":"Личные местоимения",
    "Feminine adjectives":"Женский род",
    "Masculine adjectives":"Мужской род",
    "Neuter adjectives":"Средний род",
    "Animate adjectives":"Формы прил., согласованные с одуш. сущ.",
    "Inanimate adjectives":"Формы прил., согласованные с неодуш. сущ.",
    "Singular adjectives":"Единственное число",
    "Plural adjectives":"Множественное число",
    "Degree":"Степень сравнения",
    "Positive degree":"Положительная степень",
    "Comparative degree":"Сравнительная степень",
    "Superlative degree":"Превосходная степень",
    "Form":"Форма",
    "Short Form":"Краткая форма",
    "Numerals":"Числительные",
    "All numerals":"Все числительные",
    "Feminine numerals":"Женский род",
    "Masculine numerals":"Мужской род",
    "Neuter numerals":"Средний род",
    "Singular numerals":"Единственное число",
    "Plural numerals":"Множественное число",
    "Numeral type":"Тип числительных",
    "Cardinal numerals":"Количественные числительные",
    "All Adverbs":"Все наречия",
    "All verbs":"Все глаголы",
    "Aspect":"Вид",
    "Imperfective aspect":"Несовершенный вид",
    "Perfective aspect":"Совершенный вид",
    "Mood":"Наклонение",
    "Indicative mood":"Изъявительное наклонение",
    "Conditional mood":"Условное наклонение",
    "Imperative mood Tense":"Повелительное наклонение",
    "Tense":"Время",
    "Past tense":"Прошедшее время",
    "Present tense":"Настоящее время",
    "Future tense":"Будущее время",
    "Femenine form of the verb":"Форма женского рода",
    "Masculine form of the verb":"Форма мужского рода",
    "Neuter form of the verb":"Форма среднего рода",
    "Verb in the singular":"Глагол в единственном числе",
    "Verb in the plural":"Глагол во множественном числе",
    "First person":"Первое лицо",
    "Second person":"Второе лицо",
    "Third person":"Третье лицо",
    "VerbForm":"Форма глагола",
    "Finite verb form":"Личная форма глагола",
    "Infinitive verb form":"Инфинитив",
    "Non-finite verb form":"Неличная",
    "Verb participle":"Причастие",
    "Voice":"Залог",
    "Active voice":"Действительный залог",
    "Reflexive (passive) form":"Возвратная форма",
    "Feminine verbs":"Глаголы в женском роде",
    "Masculine verbs":"Глаголы в мужском роде",
    "Neuter verbs":"Глаголы в среднем роде",
    "Singular verbs":"Глаголы в единственном числе",
    "Plural verbs":"Глаголы во множественном числе",
    "First person verbs":"Глаголы в первом лице",
    "Second person verbs":"Глаголы во втором лице",
    "Third person verbs":"Глаголы в третьем лице",
    "Finite verbs":"Личные формы глаголов",
    "Infinitive verbs":"Инфинитивы",
    "Converb verbs":"Деепричастия",
    "Participle verbs":"Причастия",
    "Middle voice":"Средний залог",
    "Passive voice":"Страдательный залог",
    "All prepositions":"Все предлоги",
    "Particles":"Частицы",
    "All particles":"Все частицы",
    "Coordinating conjunctions":"Сочинительные союзы",
    "All coordinating conjunctions":"Все сочинительные союзы",
    "Subordinating conjunctions":"Подчинительные союзы",
    "All subordinating conjunctions":"Все подчинительные союзы",
    "Punctuation marks":"Знаки препинания",
    "Number":"Число",
    "Case":"Падеж",
    "Gender":"Род"
} 